import {I18n} from '@aws-amplify/core';

import {formatTimestamp} from '../../../utils/TableTimestamps';
import {Card} from '../types';

export const getColumns = (onRecordClick?: (record: Card) => void) => [
    {
        title: I18n.get('Card'),
        width: '1fr',
        render: (item: Card) => onRecordClick ? (
            <span
                style={{color: 'var(--mantine-color-blue-6)', cursor: 'pointer'}}
                onClick={() => onRecordClick(item)}
            >
                {item.id}
            </span>
        ) : item.id,
    },
    {
        title: I18n.get('Brand'),
        width: '1fr',
        render: (item: Card) => item.brand,
    },
    {
        title: I18n.get('Expiration'),
        width: '1fr',
        render: (item: Card) => item.expMonth + '/' + item.expYear,
    },
    {
        title: I18n.get('Country'),
        width: '1fr',
        render: (item: Card) => item.country,
    },
    {
        title: I18n.get('Created'),
        width: '1fr',
        render: (item: Card) => formatTimestamp(item.created as string),
    },
];

// Keep backward-compatible export for any remaining consumers
export const columns = getColumns();
